import { BadgeType } from '@wix/members-badge-lib';
import { Member } from '@wix/members-domain-ts';

import { State } from '../../badges/typings';

export const getMemberBadges = (state: any, id: string) => {
  const badgesIds: string[] = state.members.map[id].badges;

  if (!state?.badgesDefinitions?.ids || !badgesIds) {
    return [];
  }

  return state.badgesDefinitions.ids.reduce((acc: BadgeType[], badgeId: string) => {
    const badgeDefinition = state.badgesDefinitions.byId[badgeId];
    if (badgeDefinition && badgesIds?.includes(badgeId)) {
      acc.push(badgeDefinition);
    }
    return acc;
  }, []);
};

export const memberHasBadges = (state: any, id: string) => {
  const badgesIds = state.members.map[id].badges;
  return badgesIds ? badgesIds.length > 0 : false;
};

export const membersHaveBadge = (state: State) => {
  return Object.values(state.members.map).some((member: Member) => {
    return !!member.badges?.length;
  });
};
